import type { ResourceType } from '../../domain'

export interface ConnectwareResourcesManagementService {
    /**
     * @throws {import('../../domain').ConnectwareError}
     */
    delete(type: ResourceType, ids: readonly string[]): Promise<void>

    /**
     * @throws {import('../../domain').ConnectwareError}
     */
    disable(type: ResourceType, ids: readonly string[]): Promise<void>

    /**
     * @throws {import('../../domain').ConnectwareError}
     */
    enable(type: ResourceType, ids: readonly string[]): Promise<void>

    /**
     * @throws {import('../../domain').ConnectwareError}
     */
    reenable(type: ResourceType, ids: readonly string[]): Promise<void>
}
